import { ConfigToolGuard } from '../../guards/config-tool-guard/config-tool-guard';

/**
 * Top-level `config-tool` route. Registered at the app root (not under the
 * `admin` route) so the Config Tool renders without the /admin layout chrome.
 * Lazy-loads ConfigToolModule, which defaults to the Feature Workspace and keeps
 * the Config Explorer reachable at `config-tool/explorer`.
 *
 * Access is gated to SysDAAR users (members of the `NV_SYSDAAR` cluster in good
 * standing, see ImUser.isSysDaarUser) and portal super admins via ConfigToolGuard.
 *
 * Deliberately no SessionStorageEntityIdResolver: this route has no `:entity`
 * param, so the resolver would only ever clear `entityId` from sessionStorage.
 * The Config Tool is a side trip out of the portal and nothing in it reads
 * entity context — it must leave the main portal's context untouched so
 * returning to it (back button, second tab) still has its entity.
 */
export const configToolRoute = {
  path: 'config-tool',
  url: '/config-tool',
  authenticationRequired: true,
  canActivate: [ConfigToolGuard],
  canActivateChild: [ConfigToolGuard],
  loadChildren: () =>
    import('../../../admin/config-tool/config-tool.module').then(m => m.ConfigToolModule),
};
